import React from 'react';

export const Notification = ({ message, type = 'error' }) => {
    if (!message) return null;

    let bgColor = 'bg-red-500';
    if (type === 'success') bgColor = 'bg-green-500';
    if (type === 'info') bgColor = 'bg-blue-500';
    
    // As classes do TailwindCSS estão aqui para o design da notificação.
    // 'fixed bottom-5 right-5' posiciona no canto inferior direito.
    // 'z-50' garante que fique acima de outros elementos.
    return (
        <div className={`fixed bottom-5 right-5 text-white py-2 px-4 rounded-lg shadow-lg z-50 ${bgColor}`}>
            {message}
        </div>
    );
};